import { Component, Input } from '@angular/core';
import { Packet } from '../../models/packet';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'child-info-packet',
  templateUrl: './child-info-packet.html',
  styleUrls: ['./child-info-packet.scss'],
})

export class ChildInfoPacket {

  /**
   * 패킷이 없는 경우 출력 문자열
   */
  private static DEFAULT: string = 'ㅡ';

  /**
   * 패킷 정보
   */
  private origin: Packet = null;

  constructor() {}

  @Input('packet') private set packet(pkt: Packet) {
    this.origin = pkt;
  }

  /**
   * @return {string} 총 횟수. 패킷 정보가 없으면
   */
  get total(): string {
    return this.origin &&
      SharedService.addZero(this.origin.total) || ChildInfoPacket.DEFAULT;
  }

  /**
   * @return {string} 출석 횟수. 패킷 정보가 없으면
   */
  get attend(): string {
    return this.origin &&
      SharedService.addZero(this.origin.attend) || ChildInfoPacket.DEFAULT;
  }

  /**
   * @return {string} 패킷 남은 횟수. 패킷 정보가 없으면
   */
  get remain(): string {
    return this.origin &&
      SharedService.addZero(this.origin.remain) || ChildInfoPacket.DEFAULT;
  }

  /**
   * @return {string} 추가 횟수. 패킷 정보가 없으면
   */
  get addition(): string {
    return this.origin &&
      SharedService.addZero(this.origin.service) || ChildInfoPacket.DEFAULT;
  }

  /**
   * 추가 횟수 존재 여부
   * @return {boolean} true: 1 이상. false: 패킷 정보 또는 추가 횟수가 0
   */
  hasAddition(): boolean {
    return this.origin && this.origin.service > 0;
  }
}
